// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/integration-call-schema',
  type: 'object',
  required: ['id', 'creatorId', 'integrationTaskId', 'sourceAppSystemId', 'integrationStatusId', 'runNo'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    integrationTaskId: {
      type: 'integer',
    },
    integrationTaskName: {
      type: 'string',
      nullable: true,
    },
    sourceAppSystemId: {
      type: 'integer',
    },
    sourceAppSystemName: {
      type: 'string',
      nullable: true,
    },
    integrationObject: {
      type: 'string',
      nullable: true,
    },
    integrationObjectSummary: {
      type: 'string',
      nullable: true,
    },
    integrationStatusId: {
      type: 'integer',
    },
    integrationStatusName: {
      type: 'string',
      nullable: true,
    },
    integrationStatusMessage: {
      type: 'string',
      nullable: true,
    },
    runNo: {
      type: 'integer',
    },
    correlationId: {
      type: 'string',
      nullable: true,
    },
    appTransactionId: {
      type: 'string',
      nullable: true,
    },
    appUserId: {
      type: 'integer',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
